<template>
  <div>
    <div class="form__input-wrapper">
      <label>{{ t('organization.edit.tabs.users.position') }}</label>
      <input v-model="formData.role" type="text" @input="enableSave" />
    </div>
    <button v-if="isSaving" class="button--save">
      {{ t('organization.edit.saving') }}
    </button>
    <button
      v-else
      :disabled="disabled"
      class="button--save"
      @click="handleOrganizationUserSubmit()"
    >
      {{ t('organization.edit.save') }}
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash'

const buildOrganizationUser = () => ({
  role: '',
})

export default {
  name: 'OrganizationUserForm',
  components: {},
  emits: ['submit'],
  props: {
    organizationUser: {
      type: Object,
      required: false,
      default: buildOrganizationUser,
    },
    isSaving: { type: Boolean, required: true },
  },
  data() {
    return {
      formData: cloneDeep(this.organizationUser),
      disabled: true,
    }
  },
  computed: {
    ...mapState({
      expanded: state => !state.sidebar.expanded,
    }),
  },
  methods: {
    handleOrganizationUserSubmit() {
      this.$emit('submit', {
        organizationUser: this.formData,
      })
      this.disabled = true
    },
    enableSave() {
      this.disabled = false
    },
  },
}
</script>
